import React from "react";
import { Card, Badge } from "antd";
import { CardProps } from "antd/lib/card";
import "./Card.Component.less";
import { CardC } from "..";
interface CardComponentProps extends CardProps {
  isOutline?: boolean;
  loadings?: boolean;
}
const CardComponent = (props: CardComponentProps) => {
  const {
    children,
    title,
    isOutline = false,
    loadings,
    style,
    ...antProps
  } = props;

  if (title) {
    return (
      <div style={{ margin: "0 12px" }}>
        <Badge.Ribbon text={title} placement="start">
          <Card style={{ paddingTop: "6px", overflow: "hidden" }} {...antProps}>
            <div style={{ marginTop: "12px" }}>{children}</div>
          </Card>
        </Badge.Ribbon>
      </div>
    );
  }
  const component = (props: CardComponentProps) => (
    <>
      {loadings && <CardC loading />}
      <Card
        {...props}
        style={{ display: loadings ? "none" : "block", ...style }}
      >
        {children}
      </Card>
    </>
  );
  if (isOutline) {
    return (
      <Card>
        <Card {...props} className="card_outline">
          {children}
        </Card>
      </Card>
    );
  }
  return component({ ...props });
};

export default CardComponent;
